export default {
    path: '/personnel',
    name: 'Personnel',
    component: () => import(/* webpackChunkName: "personnel" */ '../../views/personnel/personnel.vue')
}